import type { LabelMap, Option, StatusMap } from '../types/common';

/** Label for an enum value from a status map ([label, tone]) or a plain label map. */
export const labelOf = (map: StatusMap | LabelMap, key?: string | null): string => {
  if (key == null) return '';
  const v = map[key];
  return Array.isArray(v) ? v[0] : (v as string | undefined) ?? key;
};

/** { cash: 'Cash' } or { draft: ['Draft', 'grey'] } -> [{ value, label }] for a Select. */
export const toOptions = (map: StatusMap | LabelMap): Option[] =>
  Object.entries(map).map(([value, v]) => ({ value, label: Array.isArray(v) ? v[0] : (v as string) }));
